import { DOCUMENT } from '@angular/common';
import { AfterViewInit, Component, EventEmitter, Inject, Input, OnInit, Output, Renderer2 } from '@angular/core';
import { BusinessComponentService } from './../business-component.service';
import { DeleteProjectRequest } from '../models/client-project.model';
import { Subscription } from 'rxjs';

@Component({
    selector: 'delete-biz-comp',
    templateUrl: './delete-business-comp.component.html',
    styleUrls: ['./delete-business-comp.component.scss']
})

export class DeleteBusinessCompDialog implements OnInit, AfterViewInit {

    constructor(@Inject(DOCUMENT) private _document: Document, private renderer: Renderer2, private _businessComponentService: BusinessComponentService) {
    }
    @Input() selectedBusinessCompIdToDelete: number;
    @Input() engagementId: number;
  @Output() modelClose= new EventEmitter<void>();
  private routeSubscription: Subscription;
    ngOnInit(): void {       
     
    }

    ngAfterViewInit(): void {
        let modalBody = this._document.getElementById('modal-content-body') as HTMLElement;
        if (modalBody) {
            this.renderer.setStyle(modalBody, 'height', '63%');
            this.renderer.setStyle(modalBody, 'width', '35%');           
        }
    }

    closeConfimationBox() {
       this.modelClose.emit();
    }

    deleteSelectedBusinessComp() {
        const deleteRequest: DeleteProjectRequest = {
            projectId: this.selectedBusinessCompIdToDelete,
            engagementId: this.engagementId
        };
        this._businessComponentService.deleteBusinessComponent(deleteRequest).subscribe();
        this.closeConfimationBox();
    }
    ngOnDestroy()
    {
        if (this.routeSubscription) {
            this.routeSubscription.unsubscribe();
        }
    }
}
